import { styled } from '@mui/material';
import { variables } from '../styles';

export const LabelButton = styled('button')(() => ({
  padding: 0,
  backgroundColor: variables.white,
  boxShadow: 'none',
  fontSize: variables.bodyFontSize,
  fontWeight: 'bold',
  textTransform: 'none',
}));
